module.exports = __webpack_public_path__ + "img/psih1s-300x231.6d04b409.jpg";